<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  textColor: {
    type: String,
    default: 'text-white', // Default color
  },
});

const emit = defineEmits(['toggle-navbar']);
</script>

<template>
  <button
    class="ml-2 rounded-md bg-transparent text-primary transition duration-200 hover:bg-transparent md:hidden"
    :class="textColor"
    type="button"
    @click.stop="$emit('toggle-navbar')"
  >
    <svg
      class="h-11 w-11 rounded-md p-1 transition duration-300 hover:bg-primary hover:text-white focus:ring focus:ring-primary active:border-primary"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 6h16M4 12h16m-7 6h7"
      ></path>
    </svg>
  </button>
</template>
